/* global axios */
import ApiClient from './ApiClient';

class BusinessAccountAPI extends ApiClient {
  constructor() {
    super('business_accounts', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(`${this.url}`, { params });
  }

  create(businessAccountData) {
    return axios.post(`${this.url}`, businessAccountData);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  linkContacts(
    id,
    contactIds,
    force = false,
    keepBoth = false,
    contactDecisions = null
  ) {
    const payload = {
      contact_ids: contactIds,
    };

    if (contactDecisions) {
      payload.contact_decisions = contactDecisions;
    } else {
      // Legacy support
      payload.force = force;
      payload.keep_both = keepBoth;
    }

    return axios.post(`${this.url}/${id}/link_contacts`, payload);
  }

  unlinkContact(id, contactId) {
    return axios.delete(`${this.url}/${id}/unlink_contact/${contactId}`);
  }

  update(id, businessAccountData) {
    return axios.patch(`${this.url}/${id}`, businessAccountData);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getBusinessAccountByContactId(contactId) {
    return axios.get(`${this.url}/by_contact/${contactId}`);
  }
}

export default new BusinessAccountAPI();
